import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="main-footer">
      <div className="footy">
        <span style={{ fontSize: 10 }}>
          Database developed by &copy;{new Date().getFullYear()} Kyle Saunders &
          McKay Seamons
        </span>
        <span style={{ fontSize: 8, display: "inline-block" }}>
          kwsaunde@ucsc.edu (805)-452-1872 | Mseamons5@hotmail.com (559)538-4792
        </span>
      </div>
    </div>
  );
}

export default Footer;
